import React, { useState, useEffect, Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Paper, TextField, CircularProgress } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { getPagingMessages } from '../../../../../configs/environments/firebase/firebaseApp';
import { connect } from 'react-redux';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import { justifyContent } from 'styled-system';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    boxShadow: 'none',
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
    backgroundColor: 'transparent',
  },
  iconButton: {
    padding: 10,
    color: '#969696',
  },
  divider: {
    height: 28,
    margin: 4,
  },
  listElem: {
    padding: '10px 24px',
    margin: 0,
  },
  container: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between'
  },
  endAdornment: {
    paddingRight: 0,
  },
  inputRoot: {
    paddingRight: 0,
  },
  textName: {
    color: '#484848',
    fontSize: 14,
  },
  textEmail: {
    color: '#969696',
    fontSize: 14,
  },
  textSource: {
    color: '#969696',
    fontSize: 12,
  },
  Autocomplete: {
    width: '100%',
    paddingRight: 0,
    '& .MuiAutocomplete-inputRoot': {
      paddingRight: 0
    }
  },
  TextField: {
    maxWidth: 536,
    paddingRight: 0,
    margin: '0 0 2px',
    '& .MuiInputLabel-marginDense': {
      transform: 'translate(14px, 16px) scale(1) !important',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      right: 22,
      bottom: 0,
      paddingRight: 0,
    },
    '& .MuiInputLabel-shrink': {
      transform: 'translate(14px, -6px) scale(0.75) !important',
      zIndex: 10,
      right: 'unset',
      backgroundColor: '#fff',
      height: 'fit-content',
      paddingRight: 0,
    },
    
  },
}));

const SearchContact = ({ messageLaw, uid, search, setSearch, contacts, setContacts}) => {
  const classes = useStyles();

  const handleSubmit = e => {
    e.preventDefault()
  }

  const handleChange = (e, value) => {
    setSearch(value)
    if(value){
      const newItem = {
          fullName: value.name || '',
          phone: value.phone || '',
          typePhone: '',
          email: value.email || '',
          source: 'Contacta Abogado®',
        }
      console.log(value)
      let newContacts = [...contacts]
      newContacts = [...newContacts, newItem]
      setContacts(newContacts)
    }
  }

  const [ temporalValue, setTemporalValue ] = useState('')

  const inputChange = e => {
    if (e && e.target && e.target.value) {
      setTemporalValue(e.target.value)
    }
  }

  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState([]);
  const loading = open && options.length === 0;
  const [didFetch, setDidFetch] = useState(false);

  useEffect(() => {
    if (!open) {
      setOptions([]);
    }
    let active = true;
    if (!loading) {
      return undefined;
    }
    (async () => {
      try {
        let response
        if (!didFetch) {
          response = await getPagingMessages(uid, 1)
        }

        let saved =
          response && response.data ?
          response.data :
          messageLaw && messageLaw.data ?
          messageLaw.data : []

        let filteredSaved = []

        if (saved && saved.length && saved.length !== 0) {
          filteredSaved = saved.filter(elem => elem.save)
        }

        if (active) {
          setOptions(filteredSaved);
          setDidFetch(true)
        }
      } catch (error) {
        console.log('error', error);
      }
    })();
    return () => {
      active = false;
    };
  }, [didFetch, loading, messageLaw, open, uid, contacts]);


  return (
    <Paper
      component="form"
      onSubmit={handleSubmit}
      className={classes.root}
    >
      <Autocomplete
        id="search"
        open={open}
        value={search}
        disabled={contacts && contacts.length > 0}
        onChange={(e, value) => {
          handleChange(e, value)
        }}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        getOptionSelected={(option, value) => option.name === value.name || option.email === value.email}
        getOptionLabel={(option, value) => {
          if (temporalValue && temporalValue.includes('@')) {
            return option.email
          } else {
            return option.name
          }
        }}
        onInputChange={inputChange}
        noOptionsText={'No tienes contactos guardados'}
        renderOption={option => (
          <div className={classes.container}>
            <div className={classes.subContainer1}>
              <p className={classes.textName}>
                {option && option.name ? option.name : ''}
              </p>
              <p className={classes.textEmail}>
                {option && option.email ? option.email : ''}
              </p>
            </div>
            <div className={classes.subContainer2}>
              <p className={classes.textSource}>Contacta Abogado®</p>
            </div>
          </div>
        )}
        fullWidth={true}
        options={options}
        loading={loading}
        loadingText='Cargando contactos guardados'
        classes={{
          root: classes.Autocomplete,
          option: classes.listElem,
          endAdornment: classes.endAdornment,
          inputRoot: classes.inputRoot,
          input: classes.inputRoot,
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Buscar por nombre o correo electrónico"
            variant="outlined"
            classes={{
              root: classes.TextField,
            }}
            fullWidth
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <Fragment>
                  {loading ?
                    <CircularProgress
                      color="inherit"
                      size={20}
                    /> : null
                    // <IconButton
                    //   type="button"
                    //   className={classes.iconButton}
                    //   aria-label="search"
                    // >
                    //   <SearchIcon />
                    // </IconButton>
                  }
                </Fragment>
              ),
            }}
          />
        )}
      />
      {/* <InputBase
        className={classes.input}
        placeholder="Buscar por nombre, correo electrónico o teléfono"
        inputProps={{ 'aria-label': 'buscar por nombre, correo o telefono' }}
        onChange={handleChange}
      />
        <IconButton
          type="button"
          className={classes.iconButton}
          aria-label="search"
        >
        <SearchIcon />
      </IconButton> */}
    </Paper>
  )
}

const mapStateToProps = state => ({
  uid: state.authClient.uid,
  messageLaw: state.authClient.messageLaw
})

export default connect(mapStateToProps)(SearchContact);
